__turbopack_context__.v({
  "wrapper": "NextWorkNav-module__4lUWvq__wrapper",
});
